/**
 * AudioPreview Component
 * Uses react-h5-audio-player for robust, accessible audio playback
 */

import AudioPlayer from 'react-h5-audio-player';

interface AudioPreviewProps {
  className?: string;
  onError?: (error: Error) => void;
  src: string;
}

export function AudioPreview({ src, onError, className }: AudioPreviewProps) {
  const handleError = (error: Event) => {
    const target = error.target as HTMLAudioElement;
    const errorCode = target.error?.code;
    const errorMessages: Record<number, string> = {
      1: 'Audio loading was aborted',
      2: 'Network error while loading audio',
      4: 'Audio format not supported by your browser',
      3: 'Audio decoding failed - file may be corrupted',
    };

    const errorMsg = new Error(
      errorCode && errorMessages[errorCode] ? errorMessages[errorCode] : 'Failed to load audio file',
    );

    onError?.(errorMsg);
  };

  return (
    <div className={className}>
      <AudioPlayer
        src={src}
        layout="stacked"
        preload="metadata"
        className="rounded-md"
        showJumpControls={false}
        customVolumeControls={[]}
        customAdditionalControls={[]}
        onError={handleError}
      />
    </div>
  );
}
